module.exports = __webpack_public_path__ + "media/bootstrap-icons/stopwatch-fill-2d056d6c.svg";